import { EVENT_GENDERS } from "@seagames/contracts";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { z } from "zod";
import { TALLY_VIEWS, type TallySearch, TallyPage } from "../../components/tally/tally-page";
import { TALLY_SORTS } from "../../lib/medals/tally";

const DAY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * The tally's URL: the view, the filters (sport, gender, a range of games
 * days), the colour sort and the open drawer (`?noc=`) — a shared link, Back
 * and a reload all land on the same view. A malformed value is dropped.
 */
const tallySearch = z.object({
	view: z.enum(TALLY_VIEWS).optional().catch(undefined),
	sport: z.string().uuid().optional().catch(undefined),
	gender: z.enum(EVENT_GENDERS).optional().catch(undefined),
	from: z.string().regex(DAY).optional().catch(undefined),
	until: z.string().regex(DAY).optional().catch(undefined),
	sort: z.enum(TALLY_SORTS).optional().catch(undefined),
	noc: z.string().uuid().optional().catch(undefined),
});

/** The medal tally (components/tally/tally-page.tsx). */
export const Route = createFileRoute("/_app/tally")({
	validateSearch: tallySearch,
	component: function Tally() {
		const search = Route.useSearch();
		const navigate = useNavigate({ from: Route.fullPath });
		const go = useCallback((patch: Partial<TallySearch>) => void navigate({ search: (s) => ({ ...s, ...patch }), resetScroll: false }), [navigate]);
		return <TallyPage search={search} navigate={go} />;
	},
});
